import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconNotifications from './sidebar-icon-notifications.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconNotifications {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconNotifications';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconNotificationsIcon = svgIconWrapper(SvgComponent);
